import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-x-0 bottom-0 h-1/2 bg-gray-100" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "max-w-7xl mx-auto sm:px-6 lg:px-8"
}
const _hoisted_4 = { class: "relative shadow-xl sm:rounded-2xl sm:overflow-hidden" }
const _hoisted_5 = { class: "absolute inset-0" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-indigo-700 mix-blend-multiply" }, null, -1)
const _hoisted_8 = { class: "relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8" }
const _hoisted_9 = { class: "text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl" }
const _hoisted_10 = { class: "block text-white" }
const _hoisted_11 = { class: "mt-6 max-w-lg mx-auto text-center text-xl text-indigo-200 sm:max-w-3xl" }
const _hoisted_12 = { class: "mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center" }
const _hoisted_13 = { class: "space-y-4 sm:space-y-0 sm:mx-auto sm:inline-grid sm:grid-cols-1 sm:gap-5" }
const _hoisted_14 = { class: "bg-gray-100" }
const _hoisted_15 = { class: "mx-auto py-16 px-4 sm:px-6 lg:px-8" }
const _hoisted_16 = { class: "relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8" }
const _hoisted_17 = { class: "relative max-w-7xl mx-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl" }, " Active Projects ")
], -1)
const _hoisted_19 = { class: "mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none" }
const _hoisted_20 = { class: "flex-shrink-0" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "flex-1 bg-white p-6 flex flex-col justify-between" }
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "text-xl font-semibold text-gray-900 hover:underline" }
const _hoisted_26 = { class: "mt-3 text-base text-gray-500" }
const _hoisted_27 = { class: "mt-6 items-center font-extrabold text-black" }
const _hoisted_28 = { class: "w-full bg-gray-50 rounded-full dark:bg-gray-100" }
const _hoisted_29 = { class: "flex mt-5 justify-between" }
const _hoisted_30 = { class: "uppercase" }
const _hoisted_31 = { class: "flex justify-center w-full mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.projects_for_carousel &&  _ctx.projects_for_carousel.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    loading: "lazy",
                    class: "h-full w-full object-cover",
                    src: _ctx.FundraisingHost.url +'get-image/'+_ctx.projects_for_carousel[0].project_photo_file_path,
                    alt: "People working on laptops"
                  }, null, 8, _hoisted_6),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.projects_for_carousel[0].project_name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.projects_for_carousel[0].project_summary), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {_ctx.selectedProject =_ctx.projects_for_carousel[0] ; _ctx.$router.push({name:'donation',params:{id:_ctx.projects_for_carousel[0].id}})}, ["prevent"])),
                        href: "",
                        class: "flex items-center justify-center px-4 py-3 border border-transparent text-base rounded-md shadow-sm text-indigo-700 bg-white hover:bg-indigo-50 sm:px-8 font-bold"
                      }, " Donate Now ")
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectList.slice(0, 3), (project) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: project.project_name,
                  class: "flex flex-col rounded-lg shadow-lg overflow-hidden"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("img", {
                      loading: "lazy",
                      class: "h-48 w-full object-cover",
                      src: _ctx.FundraisingHost.url + 'get-image/'+project.project_photo_file_path,
                      alt: project.project_name
                    }, null, 8, _hoisted_21)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => {_ctx.selectedProject = project; _ctx.$router.push({name:'donation',params:{id:project.id}})}, ["prevent"]),
                        href: "#",
                        class: "block"
                      }, [
                        _createElementVNode("p", _hoisted_25, _toDisplayString(project.project_name), 1),
                        _createElementVNode("p", _hoisted_26, _toDisplayString(project.project_summary), 1)
                      ], 8, _hoisted_24)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          class: "bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full",
                          style: _normalizeStyle('width:'+(project.raisedAmount/project.project_target_amount)*100+'%')
                        }, _toDisplayString((project.raisedAmount/project.project_target_amount)*100) + "%", 5)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(project.project_target_currency), 1),
                          _createTextVNode(" " + _toDisplayString(project.raisedAmount) + " Raised", 1)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(project.totalDonors) + " Donations", 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_router_link, {
                to: {name:'projects'},
                class: "inline-block mx-auto underline hover:text-blue-500 capitalize font-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" See More projects ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}